// extracted by mini-css-extract-plugin
module.exports = {"error":"ScoringErrorModal_error__1e4Wl"};